import React, { useState, useEffect, useContext, useRef, memo } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import useFormSubmission from '../../../Auth/Controller/AuthController';
import ModuleService from '../../../Setup/controller/ModuleController/ModuleController';
import { SidebarContext } from '../../../Layout/SidebarContext';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';

import tippy from 'tippy.js';
import 'tippy.js/dist/tippy.css';
import JobService from "../../../Jobs/Controller/JobController";
import TeamService from "../../../Setup/controller/TeamController/TeamController";
import UserService from "../../../Setup/controller/UserController/UserController";
import { CreateEngineer } from "../../../Jobs/Controller/CreateJobEngineerController";
import { handleChange, handleUpdate } from "../../../Jobs/Controller/UpdateEngineerTimeController";
import Common from '../../../Common/Common';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import ProjectService from "../../../Setup/controller/ProjectMemberController/ProjectMemberController";
//import Draggable from 'react-draggable';
import Draggable from 'react-draggable';
import interactionPlugin, { Draggable as interactionDraggable } from '@fullcalendar/interaction'; // For FullCalendar drag and drop
import Swal from 'sweetalert2';
import DiariesLabelService from "../../../Setup/controller/DiariesLabelController/Controller/DiariesController";


import JobDetailModal from "../JobDetail";
import OppurtunityDetailModal from "../../../Oppurtunity/Views/OppurtunityDetail";
import LeadDetailModal from "../../../Lead/Views/LeadDetail";
import CreateCustomerModal from "../../../Customer/View/CreateCustomer";
import MultiSelectDropdown from "../../../Diaries/View/MultiSelectDropdown";
import CustomerHistoryService from "../../../Customer/Controller/CustomerHistoryController";
const ExternalEvent = memo(({ event }) => {
    let elRef = useRef(null);

    useEffect(() => {
        let draggable = new interactionDraggable(elRef.current, {
            eventData: function () {
                return { ...event, create: true };
            }
        });

        // a cleanup function
        return () => draggable.destroy();
    });

    return (
        <div
            ref={elRef}
            className="fc-event fc-h-event mb-1 fc-daygrid-event fc-daygrid-block-event"
            id={event.id}
            data-color={event.color}
            title={event.title}
            style={{
                backgroundColor: event.color,
                borderColor: event.color,
                cursor: "pointer"
            }}
        >
            <div className="fc-event-main">
                <div>
                    <strong style={{ "color": "#ffffff" }}>{event.title}</strong>
                </div>
            </div>
        </div>
    );
});

function DiariesView({ show, onClose, UserID, JobID, ProjectMemberList }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    const navigate = useNavigate();
    const { updateSidebarModules } = useContext(SidebarContext);
    const RoleID = localStorage.getItem('RoleID');
    const HelpLink = localStorage.getItem('HelpLink');
    const [formData, setFormData] = useState({});
    const location = useLocation();
    const url = new URL(window.location.origin + location.pathname);
    const pathname = url.pathname;
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const IsAdminLogin = localStorage.getItem('IsAdminLogin');
    const handleSubmit = useFormSubmission();
    const [errorMessage, setErrorMessage] = useState('');
    const [teams, setTeams] = useState([]);
    const [users, setUsers] = useState([]);
    // State to hold calendar events
    const [events, setEvents] = useState([]);

    // State to control calendar view (Week, Day, Month)
    const [calendarView, setCalendarView] = useState('timeGridWeek'); // Default to weekly view

    // State for slot duration
    const [slotDuration, setSlotDuration] = useState('01:00:00'); // Default to 1 hour
    const [selectedTeam, setSelectedTeam] = useState(0);
    // State to control sidebar visibility
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [activeTab, setActiveTab] = useState('engineers');
    const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]); // Default to today's date
    const calendarRef = useRef(null);
    const [ProjectList, setProject] = useState([]);
    const [ProjectID, setProjectID] = useState(localStorage.getItem("ProjectID") || ""); // Initial empty state
    const [jobList, setJobData] = useState([]);
    const [filteredJobList, setFilteredJobList] = useState([]); // Filtered job list
    const CompanyID = localStorage.getItem("CompanyID");

    const [selectedJob, setSelectedJob] = useState(null); // or initialize with the default job
    const [selectedUser, setSelectedUser] = useState(null); // or initialize with the default user
    const [selectedProject, setSelectedProject] = useState(''); // or initialize with the default project
    const [Weekened, setWeekened] = useState(true);
    const [timeOption, setTimeOption] = useState('workingHours');
    const [DiariesLabel, setDiariesLabel] = useState('Engineers');

    const [TaskList, setTaskList] = useState([]);
    const [AppointmentList, setAppointmentList] = useState([]);
    const [selectedUsers, setSelectedUsers] = useState([]);
    const [isTaskModalOpen, setIsTaskModalOpen] = useState(false);
    const [isOpportunityModalOpen, setIsOpportunityModalOpen] = useState(false);
    const [isCustomerModalOpen, setIsCustomerModalOpen] = useState(false);
    const [LeadID, setLeadID] = useState('0');
    const [OpportunityID, setOpportunityID] = useState('0');
    const [ClientCompanyID, setClientCompanyID] = useState('0');
    const [taskID, setTaskID] = useState('0');
    const handleEventReceive = async (eventInfo) => {
        const newEvent = {
            id: eventInfo.draggedEl.getAttribute("id"),
            title: eventInfo.draggedEl.getAttribute("title"),
            color: eventInfo.draggedEl.getAttribute("data-color"),
            custom: eventInfo.draggedEl.getAttribute("data-custom")
        };

        const IssueID = JobID;
        if (!IssueID || IssueID === "undefined") {
            Swal.fire('Error!', 'Please select job.', 'warning');
            fetchJobEngineers();
            return;
        }

        const UserID = newEvent.id;

        // Get start and end in local time
        const start = eventInfo.event.start; // FullCalendar gives this as a Date object
        const end = eventInfo.event.end ? eventInfo.event.end : new Date(start.getTime() + 60 * 60 * 1000); // Add 1 hour if no end

        // Format local date with leading zeros
        const padZero = (num) => (num < 10 ? `0${num}` : num);
        const formatDateTime = (d) => {
            return `${d.getFullYear()}-${padZero(d.getMonth() + 1)}-${padZero(d.getDate())} ${padZero(d.getHours())}:${padZero(d.getMinutes())}:${padZero(d.getSeconds())}`;
        };

        const startDate = formatDateTime(start);
        const endDate = formatDateTime(end);

        const postData = {
            IssueID,
            UserID,
            startDate,
            endDate,
            TotalTime: '1.00',
            TotalTravelTime: '0.00',
            PayRateID: '1'
        };

        const redirectCallback = () => navigate('/');
        const Message = await CreateEngineer(postData, redirectCallback);
        fetchJobEngineers();
    };



    const fetchAppointments = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const data = await JobService.AppointmentsForDiaries(redirectCallback);
            setAppointmentList(data);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const fetchTask = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const taskData = await JobService.TaskForDiaries(redirectCallback);
            setTaskList(taskData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    const fetchDiariesLabel = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const ClientID = localStorage.getItem('CompanyID');
            const diaireLabel = await DiariesLabelService.GetDiariesLabel(redirectCallback, ClientID);
            if (diaireLabel.length > 0) {
                setDiariesLabel(diaireLabel[0].DiariesLable);
            }
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };

    useEffect(() => {
        // Ensure the external-events element is available in the DOM
        const draggableEl = document.getElementById("external-events");

        if (!draggableEl) {
            console.error("Element #external-events not found");
            return;
        }

        // Initialize FullCalendar's Draggable only if the element exists
        new interactionDraggable(draggableEl, {
            itemSelector: ".fc-event",
            eventData: function (eventEl) {
                // Ensure the event element has the required attributes
                const id = eventEl.dataset.id;
                const title = eventEl.getAttribute("title");
                const color = eventEl.dataset.color;
                const custom = eventEl.dataset.custom;

                if (!id || !title) {
                    console.error("Event data attributes are missing");
                    return {};
                }

                // Return event data for FullCalendar
                return {
                    id,
                    title,
                    color,
                    custom,
                    create: true,
                };
            },
        });
    }, []);

    useEffect(() => {
        const fetchProject = async () => {
            try {
                const redirectCallback = () => navigate('/');
                const list = await ProjectService.GetProjectMemberByID(redirectCallback);

                const filteredList = list.filter(project => project.ID !== 0); // Remove project with ID 0
                setProject(filteredList[0]);

                if (filteredList.length > 0) {
                    let initialProjectID;

                    // Look for a default project
                    const defaultProjectList = filteredList.filter(project => project.IsDefault === "1");
                    if (defaultProjectList.length > 0) {
                        initialProjectID = defaultProjectList[0].ID;
                    } else {
                        // Set to the first project in the filtered list
                        initialProjectID = filteredList[0].ID;
                    }

                    setProjectID(initialProjectID);
                    fetchJob(initialProjectID);
                }
            } catch (error) {
                console.error('Error fetching projects:', error);
            }
        };

        fetchProject();

    }, [CompanyID, 0, 0, 0]);
    useEffect(() => {
        fetchJobEngineers();
        fetchTeams();
        fetchDiariesLabel();
        fetchTask();
        fetchAppointments();
    }, [theme]);
    useEffect(() => {
        if (teams.length > 0 && selectedTeam === 0) {
            // Set the first team as selected and fetch users for it
            const initialTeamID = teams[0].PK_Team_ID;
            setSelectedTeam(initialTeamID);
            fetchUsers(initialTeamID);
        }
    }, [teams]);
    const fetchTeams = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };
            const teamData = await TeamService.GetAllTeams(redirectCallback);
            setTeams(teamData);
        } catch (error) {
            console.error('Error fetching Teams:', error);
        }
    };
    const handleTeamChange = (event) => {
        const { value } = event.target;
        setSelectedTeam(value);
        setSelectedUser(null);
        fetchUsers(value);
    };
    const fetchUsers = async (TeamID) => {
        try {
            const redirectCallback = () => navigate('/');
            const usersData = await UserService.fetchUserByTeam(redirectCallback, TeamID);
            // Creating a new array with different attribute names
            const myusers = usersData.map(user => ({
                title: user.DisplayName,  // Change 'title' to 'name'
                color: user.Color,  // Change 'color' to 'backgroundColor'
                id: user.UserID  // Change 'id' to 'identifier'
            }));
            setUsers(myusers);
        } catch (error) {
            console.error('Error fetching users:', error);
        }
    };
    const handleChanges = (event, formData, setFormData) => {
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };
    const handleFieldChange = (event) => {

        handleChanges(event, formData, setFormData);
        if (event.target.name === "ProjectID") {
            setProjectID(event.target.value);
            setSelectedProject(event.target.value);
            setSelectedJob(null);
            fetchJob(event.target.value);
        }
    };
    const fetchJob = async (projectID) => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const jobsData = await JobService.GetAllJobs(redirectCallback, 0, 0, 0, 0, projectID);
            console.log("Jobs :", jobsData);
            setJobData(jobsData);
        } catch (error) {
            console.error('Error fetching jobs:', error);
        }
    };
    const fetchJobEngineers = async () => {
        try {
            const redirectCallback = () => {
                navigate('/'); // Redirect to the login page
            };

            const jobEngineers = await JobService.GetJobEnginnerTime(redirectCallback, 0);
            console.log('Current Theme:', theme);
            // Transform fetched data to match FullCalendar's event format
            const formattedEvents = jobEngineers.map(engineer => ({
                title: engineer.IssueTitle, // Add DisplayName and SupervisorName to the title
                start: engineer.StartTime, // Ensure the time format is compatible with FullCalendar
                end: engineer.EndTime, // Ensure the time format is compatible with FullCalendar
                backgroundColor: engineer.Color,
                description: engineer.DisplayName,
                IssueID: engineer.IssueID,
                UserID: engineer.UserID,
                EngineerTimeID: engineer.EngineerTimeID
            }));

            const taskData = await JobService.TaskForDiaries(redirectCallback);
            const taskEvents = taskData.map(task => ({
                title: task.Type, // Modify as per your data structure
                start: task.StartTime, // Ensure the time format is compatible with FullCalendar
                end: task.EndTime, // Ensure the time format is compatible with FullCalendar
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "task"
            }));

            const appointmentData = await JobService.AppointmentsForDiaries(redirectCallback);
            const appointmentEvents = appointmentData.map(task => ({
                title: task.Type, // Modify as per your data structure
                start: task.StartTime, // Ensure the time format is compatible with FullCalendar
                end: task.EndTime, // Ensure the time format is compatible with FullCalendar
                backgroundColor: task.Color,
                description: task.vc_Description,
                IssueID: task.ID,
                UserID: task.LeadID,
                EngineerTimeID: task.ID,
                IsLead: task.Lead,
                eventType: "opportunity"
            }));

            setEvents([...formattedEvents, ...taskEvents, ...appointmentEvents]);
        } catch (error) {
            console.error('Error fetching job engineers:', error);
        }
    };


    const handleDateClick = async (arg) => {
        if (selectedUser == null) {
            Swal.fire(
                'Error!',
                'Please drag and drop a engineer from  Engineers list.',
                'warning'
            );
            return false;
        }
        const redirectUserList = () => {
            navigate('/JobsList?saved=true');
        };
        const IssueID = JobID;
        const UserID = selectedUser;
        const date = new Date(arg.dateStr);
        const padZero = (num) => (num < 10 ? `0${num}` : num);
        const startDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
        date.setHours(date.getHours() + 1);
        const endDate = `${date.getFullYear()}-${padZero(date.getMonth() + 1)}-${padZero(date.getDate())} ${padZero(date.getHours())}:${padZero(date.getMinutes())}:${padZero(date.getSeconds())}`;
        const TotalTime = '1.00';
        const TotalTravelTime = '0.00';
        const PayRateID = '1';

        const postData = {
            IssueID,
            UserID,
            startDate,
            endDate,
            TotalTime,
            TotalTravelTime,
            PayRateID,
        };
        const redirectCallback = () => navigate('/');
        const Message = await CreateEngineer(postData, redirectCallback);
        let JobCostID = localStorage.getItem('JobCostID');
        JobCostID = JobCostID + 1;
        localStorage.setItem('JobCostID', JobCostID);
        redirectUserList();
        fetchJobEngineers();
    };
    const handleViewChange = (e) => {
        const selectedValue = e.target.value;

        // Handle "Work Week" case by setting view and hiding weekends
        if (selectedValue === 'workWeek') {
            setCalendarView('timeGridWeek'); // Display timeGridWeek for work week
            setWeekened(false); // Hide weekends for work week
        } else {
            setCalendarView(selectedValue); // Update to the selected view
            setWeekened(true); // Show weekends for other views like "Full Week"
        }
    };

    // Handle dropdown change for slot duration
    const handleSlotDurationChange = (e) => {
        setSlotDuration(e.target.value);
    };

    // Compute slotMinTime and slotMaxTime based on the calendarView and slotDuration
    const computeSlotTimes = () => {
        let slotMinTime = '00:00:00';
        let slotMaxTime = '24:00:00';

        if (calendarView === 'timeGridDay' || calendarView === 'timeGridWeek') {
            // Adjust slotMinTime and slotMaxTime to show the full range if necessary
        }

        return { slotMinTime, slotMaxTime };
    };

    const handleEventRender = (info) => {
        const { eventType } = info.event.extendedProps;
        const iconMap = {
            job: '<i class="icofont-briefcase" style={{ marginRight: "5px" }}></i>',
            task: '<i class="icofont-check" style={{ marginRight: "5px" }}></i>',
            opportunity: '<i class="icofont-clock-time" style={{ marginRight: "5px" }}></i>',
        };

        const iconHtml = iconMap[eventType] || '';
        info.el.querySelector('.fc-event-title').innerHTML = `${iconHtml}${info.event.title}`;

        // Add tooltip and background color
        tippy(info.el, {
            content: info.event.extendedProps.description,
            allowHTML: true,
        });
        info.el.style.backgroundColor = info.event.extendedProps.backgroundColor;
    };

    const { slotMinTime, slotMaxTime } = computeSlotTimes();

    // Function to toggle sidebar
    const toggleSidebar = () => {
        setIsSidebarOpen(!isSidebarOpen);
    };
    const handleTabClick = (tab) => {
        debugger;
        setActiveTab(tab);
    };
    const [checkboxState, setCheckboxState] = useState({});
    const handleCheckboxChange = (event) => {
        const { name, checked } = event.target;
        setCheckboxState({ ...checkboxState, [name]: checked });
    };
    // JobController.js
    const handleEventDrop = async (eventDropInfo) => {

        const { id } = eventDropInfo.event;
        const { sourceId, start, end } = eventDropInfo.event;
        const { eventType } = eventDropInfo.event._def.extendedProps;

        const formatDateWithoutTimezone = (date) => {
            return new Date(date).toISOString().slice(0, 19).replace("T", " "); // Convert to UTC format
        };
        const formatDate = (date) => {
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
            const year = date.getFullYear();
            const hours = String(date.getHours()).padStart(2, '0');
            const minutes = String(date.getMinutes()).padStart(2, '0');
            const seconds = String(date.getSeconds()).padStart(2, '0');
            return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
        };


        if (eventType != "task" && eventType != "opportunity") {
            const JobID = eventDropInfo.event._def.extendedProps.IssueID;
            const UserId = eventDropInfo.event._def.extendedProps.UserID;
            const EngineerTimeID = eventDropInfo.event._def.extendedProps.EngineerTimeID;


            const StartTime = formatDate(new Date(start));
            const EndTime = formatDate(new Date(end));

            const { oldEvent } = eventDropInfo;
            const PreviousStartTime = formatDate(new Date(oldEvent.start));
            const PreviousEndTime = formatDate(new Date(oldEvent.end));

            const data = {
                JobID,
                UserId,
                StartTime,
                EndTime,
                PreviousStartTime,
                PreviousEndTime,
                EngineerTimeID
            };

            try {
                const message = await handleUpdate(data);
                fetchJobEngineers();

            } catch (error) {
                eventDropInfo.revert();
            }
        }
        else if (eventType === "task") {
            eventDropInfo.snt_CommunicationType = "2";
            if (eventDropInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "0") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "2") {

                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }
            await fetchTask();
            await fetchAppointments();
            await fetchJobEngineers();
            return false;
        } else if (eventType === "opportunity") {

            eventDropInfo.snt_CommunicationType = "3";
            if (eventDropInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "0") {

                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventDropInfo.event._def.extendedProps.IsLead === "2") {
                let ID = eventDropInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);
            }


            await fetchTask();
            await fetchAppointments();
            await fetchJobEngineers();
            return false;
        }
    };
    const handleDateChange = (event) => {
        const date = event.target.value;
        setSelectedDate(date);
        const calendarApi = calendarRef.current.getApi();
        calendarApi.gotoDate(date); // Navigate to selected date
    };
    const handleRowClick = (userId) => {
        setSelectedUser(userId);
    };
    const onCloseDepots = () => {
        setIsSidebarOpen(false);
    };

    const handleEventResize = async (eventResizeInfo) => {

        const { id } = eventResizeInfo.event;
        const { sourceId, start, end } = eventResizeInfo.event;
        const { eventType } = eventResizeInfo.event._def.extendedProps;

        const formatDateWithoutTimezone = (date) => {
            return new Date(date).toISOString().slice(0, 19).replace("T", " "); // Convert to UTC format
        };

        if (eventType != "task" && eventType != "opportunity") {
            const redirectUserList = () => {
                navigate('/JobsList?saved=true');
            };
            const JobID = eventResizeInfo.event._def.extendedProps.IssueID;
            const UserId = eventResizeInfo.event._def.extendedProps.UserID;
            const EngineerTimeID = eventResizeInfo.event._def.extendedProps.EngineerTimeID;

            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
            };
            const StartTime = formatDate(new Date(start));
            const EndTime = formatDate(new Date(end));

            const { oldEvent } = eventResizeInfo;
            const PreviousStartTime = formatDate(new Date(oldEvent.start));
            const PreviousEndTime = formatDate(new Date(oldEvent.end));
            const data = {
                JobID,
                UserId,
                StartTime,
                EndTime,
                PreviousStartTime,
                PreviousEndTime,
                EngineerTimeID
            };

            try {
                const message = await handleUpdate(data);
                let JobCostID = localStorage.getItem('JobCostID');
                JobCostID = JobCostID + 1;
                localStorage.setItem('JobCostID', JobCostID);
                fetchJobEngineers();
                // redirectUserList();
            } catch (error) {
                eventResizeInfo.revert();
            }
        }
        else if (eventType === "task") {
            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
            };
            eventResizeInfo.snt_CommunicationType = "2";
            if (eventResizeInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "0") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "2") {

                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "2";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);

            }
            await fetchTask();
            await fetchAppointments();
            await fetchJobEngineers();
            return false;
        } else if (eventType === "opportunity") {
            const formatDate = (date) => {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
                const year = date.getFullYear();
                const hours = String(date.getHours()).padStart(2, '0');
                const minutes = String(date.getMinutes()).padStart(2, '0');
                const seconds = String(date.getSeconds()).padStart(2, '0');
                return `${year}/${month}/${day} ${hours}:${minutes}:${seconds}`;
            };
            eventResizeInfo.snt_CommunicationType = "3";
            if (eventResizeInfo.event._def.extendedProps.IsLead === "1") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "0") {

                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const LeadData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCommunication(LeadData);
            }
            else if (eventResizeInfo.event._def.extendedProps.IsLead === "2") {
                let ID = eventResizeInfo.event._def.extendedProps.IssueID;
                let snt_CommunicationType = "3";
                const StartTime = formatDateWithoutTimezone(start);
                const EndTime = formatDateWithoutTimezone(end);
                const customerData = {
                    ID,
                    snt_CommunicationType,
                    StartTime,
                    EndTime
                };
                await CustomerHistoryService.UpdateCustomerHistory(customerData);
            }


            await fetchTask();
            await fetchAppointments();
            await fetchJobEngineers();
            return false;
        }
    };
    const handleEventClick = async (info) => {
        debugger;
        const { eventType } = info.event._def.extendedProps;
        if (eventType != "task" && eventType != "opportunity") {
            Swal.fire({
                title: 'Are you sure?',
                text: `Are you sure you want to delete this event: ${info.event.title}?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    try {
                        const EngineerTimeID = info.event._def.extendedProps.EngineerTimeID;
                        const redirectCallback = () => navigate('/');
                        await JobService.DeleteEngineerByID(redirectCallback, EngineerTimeID);
                        fetchJobEngineers();
                        Swal.fire(
                            'Deleted!',
                            'Your record has been deleted.',
                            'success'
                        );
                    } catch (error) {
                        console.error('Error deleting job:', error);
                        Swal.fire(
                            'Error!',
                            'There was a problem deleting the record.',
                            'error'
                        );
                    }
                }
            });
        }
        else if (eventType === "task") {
            if (info.event._def.extendedProps.IsLead === "1") {
                setLeadID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsOpportunityModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "0") {
                setOpportunityID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsTaskModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "2") {
                setClientCompanyID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                localStorage.setItem('ClientCompanyID', info.event._def.extendedProps.UserID);
                setIsCustomerModalOpen(true);
            }
        } else if (eventType === "opportunity") {

            if (info.event._def.extendedProps.IsLead === "1") {
                setLeadID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsOpportunityModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "0") {

                setOpportunityID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                setIsTaskModalOpen(true);
            }
            else if (info.event._def.extendedProps.IsLead === "2") {
                setClientCompanyID(info.event._def.extendedProps.UserID);
                setTaskID(info.event._def.extendedProps.IssueID);
                localStorage.setItem('ClientCompanyID', info.event._def.extendedProps.UserID);
                setIsCustomerModalOpen(true);
            }
        }
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }
    const handleStartPopup = (e, ui) => {
        e.stopPropagation();
    }
    const handleColorChange = async (userID, newColor) => {
        try {
            await UserService.UpdateColor(userID, newColor);
            setUsers((prevUsers) =>
                prevUsers.map((user) =>
                    user.UserID === userID ? { ...user, color: newColor } : user
                )
            );
            fetchUsers(selectedTeam);
            fetchJobEngineers();
            // After color change, update the corresponding .fc-h-event class
            updateEventColor(userID, newColor);
        } catch (error) {
            console.error("Failed to update color:", error);
        }
    };

    const updateEventColor = (userID, newColor) => {
        // Assuming that the event has a data attribute or className with userID
        const eventElements = document.querySelectorAll(`.fc-h-event[data-userid="${userID}"]`);
        eventElements.forEach((eventEl) => {
            eventEl.style.backgroundColor = newColor; // Change background color of the event
        });
    };
    const handleWeekenedChange = (e) => {
        // Convert the string value to true/false
        const isWeekend = e.target.value === "true";
        setWeekened(isWeekend);  // Set the state with the boolean value
    };
    const handleCloseLeadModal = async () => {
        await fetchJobEngineers();
        await fetchTeams();
        await fetchDiariesLabel();
        await fetchTask();
        await fetchAppointments();
        setIsTaskModalOpen(false);
        setIsOpportunityModalOpen(false);
        setIsCustomerModalOpen(false);
    };
    const handleCloseOpportunityModal = async () => {
        await fetchJobEngineers();
        await fetchTeams();
        await fetchDiariesLabel();
        await fetchTask();
        await fetchAppointments();
        setIsOpportunityModalOpen(false);
        setIsTaskModalOpen(false);
        setIsCustomerModalOpen(false);
    };
    const handleCloseCustomerModal = async () => {
        await fetchJobEngineers();
        await fetchTeams();
        await fetchDiariesLabel();
        await fetchTask();
        await fetchAppointments();
        setIsCustomerModalOpen(false);
        setIsTaskModalOpen(false);
        setIsOpportunityModalOpen(false);

    };

    return (

        <div>



            {isSidebarOpen && (
                <Draggable handle=".tblEnginner" onStart={handleStartPopup}>

                    <div className={`right-sidebar-job ${isSidebarOpen ? 'open' : ''}`}>

                        <table className="table m-0 table-hover tblEnginner" style={{ width: '100%', tableLayout: 'fixed', cursor: "pointer" }}>
                            <thead style={{ "background": "rgb(77, 138, 192)" }}>
                                <tr>
                                    <th style={{ "width": "90%" }}>Engineers</th>
                                    <th>
                                        <button type="button" className="close" aria-label="Close" onClick={onCloseDepots}>
                                            <span aria-hidden="true">&times;</span>
                                        </button>
                                    </th>
                                </tr>
                            </thead>
                        </table>

                        <div className="tab-pane fade show active tableDraggable">

                            <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px" }}>
                                <label htmlFor="TeamID" className="col-form-label">
                                    <strong>Select Team:</strong>
                                </label>

                                <select name="TeamID" className='form-control' onChange={handleTeamChange}>
                                    {teams.map((team) => (
                                        <option key={team.PK_Team_ID} value={team.PK_Team_ID}>
                                            {team.vc_Name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            {/* Engineering Details */}
                            <div className="row mb-3" style={{ "marginLeft": "0px", "marginRight": "0px", "marginTop": "10px" }}>
                                <div className="divTable">
                                    <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                        <thead>
                                            <tr>
                                                <th style={{ "width": "10%" }}></th>
                                                <th>Name</th>
                                                <th>Color</th>
                                            </tr>
                                        </thead>
                                    </table>
                                    <div style={{ maxHeight: "150px", minHeight: "150px", overflow: "auto" }}>
                                        <table className="table m-0 table-hover" style={{ width: '100%', tableLayout: 'fixed' }}>
                                            <tbody id='external-events'>
                                                {
                                                    users.map((user) => (
                                                        <tr key={user.id}>
                                                            <td>
                                                                <ExternalEvent key={user.id} event={user} />
                                                            </td>
                                                            <td><input
                                                                style={{ width: "25px", height: "20px", border: "none" }}
                                                                type="color"
                                                                value={user.color}  // Use user.Color to set the initial color
                                                                onChange={(e) => handleColorChange(user.id, e.target.value)}
                                                            /></td>
                                                        </tr>
                                                    ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    -
                                </div>
                            </div>





                            <div class='row mb-3' style={{ "marginLeft": "0px", "marginRight": "0px" }}>
                                <label htmlFor="CustomerID" className="col-form-label"><strong> Date: </strong></label>
                                <input
                                    type="date"
                                    id="datepicker"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    className="form-control"
                                />
                            </div>

                        </div>

                    </div>

                </Draggable>
            )}
            <div className={`modal fade ${show ? 'show' : ''}`} style={{ display: show ? 'block' : 'none' }} tabIndex="-1" aria-labelledby="DiariesModalLabel" aria-hidden={!show}>
                <div className="modal-dialog  modal-lg" style={{ "maxWidth": "80%"}}>
                    <Draggable handle=".modal-content" onStart={handleStart}
                        cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title" id="diariesModalLabel">Engineers Schedule</h5>
                                <span>

                                    <button type="button" className="btn-close" style={{ "marginLeft": "5px" }} onClick={onClose} aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>

                                </span>
                            </div>



                            <div className="modal-body">

                                <div className="row">
                                    <div className="col-xl-12">
                                        <div className="card mb-30">
                                            <div className="card-body">
                                                <div className="table-responsive">



                                                    <div className="row mb-3">

                                                        <div className="col-sm-2">
                                                            <select className='form-control' id="calendarView" value={calendarView === 'timeGridWeek' && !Weekened ? 'workWeek' : calendarView} onChange={handleViewChange}>
                                                                <option value="timeGridWeek">Full Week</option>
                                                                <option value="workWeek">Work Week</option> {/* Custom Work Week Option */}
                                                                <option value="timeGridDay">Day</option>
                                                                <option value="dayGridMonth">Month</option>
                                                            </select>
                                                        </div>

                                                        <div className="col-sm-2">
                                                            <select className='form-control' id="slotDuration" value={slotDuration} onChange={handleSlotDurationChange}>
                                                                <option value="00:15:00">15 Minutes</option>
                                                                <option value="00:30:00">30 Minutes</option>
                                                                <option value="01:00:00">1 Hour</option>
                                                            </select>
                                                        </div>

                                                    </div>

                                                    <div className="calendar-container" style={{height:"550px",overflow:"auto"}}>
                                                        <div className="sidebar-toggle-btn" onClick={toggleSidebar}>
                                                            {isSidebarOpen ? `Close ${DiariesLabel}` : `Open ${DiariesLabel}`}
                                                        </div>
                                                        
                                                            <FullCalendar
                                                                ref={calendarRef}
                                                                plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                                                                initialView={calendarView}
                                                                view={calendarView}
                                                                editable={true}
                                                                events={events}
                                                                dateClick={handleDateClick}
                                                                slotDuration={slotDuration}
                                                                slotMinTime={slotMinTime}
                                                                slotMaxTime={slotMaxTime}
                                                                scrollTime="08:00:00"
                                                                slotLabelInterval={slotDuration} // Adjust label interval to match slot duration
                                                                key={calendarView}
                                                                eventMouseEnter={handleEventRender}
                                                                eventDidMount={handleEventRender}
                                                                eventDrop={handleEventDrop}
                                                                eventReceive={handleEventReceive}
                                                                eventResize={handleEventResize}
                                                                eventClick={handleEventClick}
                                                                weekends={Weekened}
                                                                buttonText={{
                                                                    today: 'Today'
                                                                }}
                                                                timeZone="local"
                                                            />
                                                       
                                                    </div>


                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Draggable>
                </div>
                {isTaskModalOpen && (
                    <OppurtunityDetailModal OpportunityID={OpportunityID} onClose={handleCloseOpportunityModal} onSuccess={fetchTask} IsDiaries={"1"} CommunicationID={taskID} />
                )}
                {isOpportunityModalOpen && (
                    <LeadDetailModal modalInstance={""} LeadID={LeadID} onClose={handleCloseLeadModal} onSuccess={fetchAppointments} IsDiaries={"1"} CommunicationID={taskID} />
                )}

                {isCustomerModalOpen && (
                    <CreateCustomerModal
                        ClientCompanyID={ClientCompanyID}
                        onClose={handleCloseCustomerModal}
                        onSuccess={fetchTask}
                        IsDiaries={"1"}
                        CommunicationID={taskID}
                    />
                )}
            </div>
        </div>
    );
}
export default DiariesView;